import { atom } from 'recoil';


const settingsAtom = atom({
  key: 'settings',
  default: {}
});


export { settingsAtom };